import { useQuery } from "@tanstack/react-query";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui/components/select";
import { selectPillClass } from "@/components/kit/pill-classes";
import { api, type DataSource } from "@/lib/api";

const ALL = "__all";

export function ProjectPicker({
  value,
  onChange,
  source,
}: {
  value: string | undefined;
  onChange: (project: string | undefined) => void;
  /** Omit to list projects from every source. */
  source?: DataSource;
}) {
  const { data } = useQuery({ queryKey: ["projects", 0, source], queryFn: () => api.projects(0, source ?? "all"), staleTime: 30_000 });
  return (
    <Select value={value ?? ALL} onValueChange={(v) => onChange(v === ALL ? undefined : v)}>
      <SelectTrigger className={`min-w-40 ${selectPillClass}`}>
        <SelectValue placeholder="All projects" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL}>All projects</SelectItem>
        {value && !data?.some((p) => p.project === value) ? <SelectItem value={value}>{value}</SelectItem> : null}
        {data?.map((p) => (
          <SelectItem key={p.project} value={p.project}>
            {p.project}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
